export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";